// removed by extract-text-webpack-plugin
module.exports = {"root":"CapacityFilter__root__1z1CS","filtersWrapper":"CapacityFilter__filtersWrapper__1Ub8C","footer":"CapacityFilter__footer__37Uwg","input":"CapacityFilter__input__2WDBr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CapacityFilter/CapacityFilter.css
// module id = 1619
// module chunks = 0